import React from "react";
import UpdatesBanner from "../UpdatesBanner/UpdatesBanner";
import SolutionEcosystem from "../WebSite/SolutionEcosystem/SolutionEcosystem";
import { Container } from "@material-ui/core";
import CTA from "../CTA/CTA";
import RegistryGatewayBenefits from "./RegistryGatewayBenefits";
import RegistryGatweayFeatures from "./RegistryGatweayFeatures";
import OverviewFeatures from "../OverviewFeatures/OverviewFeatures";
// Main component for RegistryGateway
export default function RegistryGateway() {
  // Data arrays for different features of the Registry Gateway
  const data1 = [
    "Register Gateway: Track and Trace API offers Agri-asset Live Monitoring, enabling real-time tracking and surveillance of agricultural assets for enhanced security and management.",
    "OTP Plug-in: Track and Trace API includes Agri-Asset Geofence, allowing users to set virtual boundaries for agricultural assets, enhancing security and monitoring capabilities.",
    "Registry (User/Solutions): Track and Trace API offers Order Tracking, providing real-time visibility into the status and location of agricultural orders for streamlined logistics management.",
    "Solution Service: Track and Trace API allows for the tracking and documentation of the origin, journey, and authenticity of products or assets throughout their lifecycle.",
  ];

  const data2 = [
    "Auth Backend Service: Track and Trace API includes Trip Management, allowing for efficient planning, monitoring, and optimization of agricultural transportation routes and schedules.",
    "OpUser Service: IAM validates access tokens, ensuring secure and authorized access to resources and services within the system based on defined policies and permissions.",
    "Client & User Identity Management: IAM validates access tokens, ensuring secure and authorized access to resources and services within the system based on defined policies and permissions.",
    "DB: The database (db) stores configurations, device metadata, topics, and commands, serving as a central repository for managing crucial system information and facilitating efficient data retrieval and manipulation.",
  ];

  return (
    <>
      {/* Banner Section with Registry Experience */}
      <UpdatesBanner
        className="sdh-bg"
        bannerTitle={["Registry Experience"]}
        bannerbodycopy="Agribusiness Registry | Partner Registry | Solution Activation | Auth Stack | Lookup"
      />

      {/* Solution Overview Section */}
      <SolutionEcosystem title="Overview" type="RegistryGateway" />

      {/* Overview of Registry Features */}
      <Container>
        <OverviewFeatures data1={data1} data2={data2} />
      </Container>

      {/* Registry Gateway Features and Benefits */}
      <RegistryGatweayFeatures />
      <RegistryGatewayBenefits />

      {/* Call-to-Action Section */}
      <Container className="subSectionWrapper">
        <CTA
          href4="http://35.92.73.23:8081/v2/api-docs/"
          heading="Do you want to develop applications or integrate your legacy hardware and software..."
        />
      </Container>
    </>
  );
}
